import { Component, OnInit, Input } from '@angular/core';
import { LoanOfferTypeEnum } from '../../../api/models/loan-offer';
import { CookieHelperService } from '../../services/cookie-helper.service';
import { BuyProgram } from '../../../api/models/buy-programs';
import { GAPCalculator } from '../../../shared/services/gap-calculator';

@Component({
  selector: 'app-selected-loan-offer',
  templateUrl: './selected-loan-offer.component.html',
  styleUrls: ['./selected-loan-offer.component.scss']
})

export class SelectedLoanOfferComponent implements OnInit {

    @Input() isClassic: boolean;
    @Input() isFromSelected: boolean;
    @Input() isGapSelected: boolean = null;
    @Input() selectedBuyProgram: BuyProgram;

    private gapCalculator: GAPCalculator;

    constructor(
        private cookieService: CookieHelperService
    ) {
        this.gapCalculator = new GAPCalculator();
    }

    ngOnInit() { }

    get loanType (): LoanOfferTypeEnum {
        if (!this.selectedBuyProgram) {
            return LoanOfferTypeEnum.Basic;
        }
        return <LoanOfferTypeEnum> (parseFloat(this.selectedBuyProgram.OfferType) - 1);
    }

    get fromSelected (): boolean {
        const isFromSelected = this.cookieService._getCookie('isFromSelectOffer');
        if (isFromSelected !== undefined && isFromSelected !== null) {
            return isFromSelected;
        }
        if (this.isFromSelected !== undefined && this.isFromSelected !== null) {
            return this.isFromSelected;
        }
        return true;
    }

    get downPayment (): number {
        if (this.selectedBuyProgram) {
            return Number(this.selectedBuyProgram.DownPayment.toString().replace(/[\,,-]/g, ''));
        }
        return 0;
    }

    get monthlyPayment (): number {
        if (!this.selectedBuyProgram) {
            return this.selectedBuyProgram.MonthlyPayment.toString().replace(/[\,,-]/g, '');
        }
        return 0;
    }

    titleHolderBg() {
        switch (this.loanType) {
            case LoanOfferTypeEnum.Basic:
                return 'bg-green';
            case LoanOfferTypeEnum.Lowest:
                return 'bg-blue';
            case LoanOfferTypeEnum.NameYourPayment:
                return 'bg-blue-dark';
            default:
                break;
        }
    }

    totalMonthlyPayment(monthlyPayment) {
        const gap = this.gapAmount;
        if (gap) {
            return Number(gap) + Number(monthlyPayment);
        }
        return monthlyPayment;
    }

    buyProgramTitle() {
        const buyProgramType = [
            'Basic Offer',
            'Lowest APR',
            'Name Your Payment',
            'Selected Car Offer'
        ];
        if (this.isClassic) {
            return 'Offer';
        }
        if (!this.fromSelected) {
            return buyProgramType[3];
        }
        return buyProgramType[this.loanType];
    }

    get gapAmount (): string {
        if (this.isGapSelected === null && this.selectedBuyProgram) {
            if (!this.selectedBuyProgram.IsGAPWaiverSelected) {
                return null;
            }
        } else {
            if (!this.isGapSelected) {
                return null;
            }
        }

        const GAPAmount = this.selectedBuyProgram.GAPWaiverAmount;
        const annualInterestRate = 15;
        const terms = this.selectedBuyProgram.Terms;
        return this.gapCalculator.calculatePmt(GAPAmount, annualInterestRate, terms);
    }

}



// WEBPACK FOOTER //
// ./src/app/shared/components/selected-loan-offer/selected-loan-offer.component.ts